import Images from "./Images";
import Description from "./Description";

type ProfileCardProps = {
  title: string;
  subtitle: string;
};

export const ProfileCard = ({ title, subtitle }: ProfileCardProps) => {
  return (
    <div className="profile-wrapper">
      <div className="profile-container">
        <Images
          margin="0 8px 0 0"
          mobileWidth="24px"
          width="40px"
          url="/static/images/svg/managerSVG.svg"
        ></Images>
        <div className="text">
          <Description
            fontSize="12px"
            fontWeight="bold"
            font="Roboto"
            margin="0px"
            text={title}
            align="left"
          ></Description>
          <Description
            fontSize="12px"
            font="Roboto"
            fontWeight="bold"
            margin="0px"
            text={subtitle}
            color="var(--color-gray-lighter)"
          ></Description>
        </div>
      </div>
      <style jsx>{`
        .profile-container {
          display: flex;
        }
        .text {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
        }
        .profile-wrapper {
          width: 240px;
          background-color: var(--color-white);
          box-shadow: 0 2px 4px 0 rgba(64, 64, 64, 0.2);
          border-radius: 8px;
          margin: 16px;
          padding: 16px;
        }
        @media only screen and (max-width: 600px) {
          .profile-wrapper {
            width: 222px;
            margin: 8px;
            padding: 8px;
          }
        }
      `}</style>
    </div>
  );
};
